import Slider_body from "./Slider_body";
import Slider_title from "./Slider_title";

function Slider() {
  return (
        <div className=" position-relative">
          <Slider_title/>
          <Slider_body/>
        </div>
  );
}

export default Slider;
